'use client';

import React, { useEffect, useState } from 'react';
import { allowPageScroll, blockPageScroll } from '@/utils/storeSetters';
import * as Styled from './Modal.styled';

interface IModal {
  className?: string;
  toggleModalEventName?: string;
  children?: React.ReactNode;
  displayModal?: boolean;
  closeOnOutsideClick?: boolean;
  positionContent?: 'middle' | 'bottom';
}
export const Modal: React.FC<IModal> = ({
  toggleModalEventName,
  className,
  displayModal = false,
  closeOnOutsideClick = true,
  positionContent = 'middle',
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(displayModal);

  useEffect(() => {
    setIsOpen(displayModal);
  }, [displayModal]);

  useEffect(() => {
    if (toggleModalEventName) {
      window.addEventListener(toggleModalEventName, toggleModal);
      return () => {
        window.removeEventListener(toggleModalEventName, toggleModal);
      };
    }
  }, [toggleModalEventName]);

  const toggleModal = () => {
    setIsOpen((prev) => {
      return !prev;
    });
  };

  useEffect(() => {
    if (isOpen) {
      blockPageScroll();
    } else {
      allowPageScroll();
    }
  }, [isOpen]);

  return (
    <Styled.ModalContainer
      className={className ?? ''}
      isOpen={isOpen}
      positionContent={positionContent}
    >
      <Styled.Overlay onClick={closeOnOutsideClick ? toggleModal : undefined} />
      {children}
    </Styled.ModalContainer>
  );
};
